import React, { memo, forwardRef } from "react";
const SvgCurlybrackets = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M14.044 13.816h0l-.001.003c-.222.46-.586.775-1.102.947-.271.084-.485.207-.631.373a.898.898 0 00-.221.613c0 .238.072.444.22.613.147.166.36.289.632.373.516.172.88.488 1.102.947h0l.001.003c.241.465.367 1.174.367 2.141v4.536c0 1.2.272 2.087.84 2.636.566.566 1.434.839 2.581.839h.675c.283 0 .514-.063.674-.208.163-.146.236-.36.236-.621s-.073-.475-.236-.621c-.16-.145-.391-.208-.674-.208h-.54c-.61 0-1.013-.182-1.24-.522-.217-.336-.334-.87-.334-1.619v-4.617c0-1.029-.203-1.863-.617-2.492-.373-.566-.913-.958-1.613-1.18.7-.222 1.24-.614 1.613-1.18.415-.63.617-1.463.617-2.492V7.463c0-.75.117-1.283.334-1.619.227-.34.63-.522 1.24-.522h.54c.283 0 .514-.063.674-.208.163-.146.236-.36.236-.621s-.073-.475-.236-.621c-.16-.145-.391-.208-.674-.208h-.675c-1.147 0-2.015.273-2.581.839-.568.55-.84 1.437-.84 2.636v4.536c0 .967-.126 1.676-.367 2.141z"
      />
    </svg>
  );
});
SvgCurlybrackets.displayName = "SvgCurlybrackets";
const MemoForwardRef = memo(SvgCurlybrackets);
export default MemoForwardRef;
